import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-8 text-center sm:p-12',
        className,
      )}
    >
      {icon && (
        <div
          className="mb-4 grid h-14 w-14 place-items-center rounded-full bg-slate-100 text-ink-3 dark:bg-slate-800 dark:text-slate-400"
          aria-hidden
        >
          {icon}
        </div>
      )}
      <h3 className="text-base font-bold text-ink dark:text-slate-100">{title}</h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-xs leading-relaxed text-ink-3 dark:text-slate-400">
          {description}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export default EmptyState;
